import { Q, QueryBuilder } from "./queryBuilder.js";
import { sendToNative } from './reactNativeBridge.js';

const messageType = "watermelonDb";

class QueryRequest {
  constructor(collectionName, options) {
    this.collectionName = collectionName;
    this.options = options;
    this._dataPromise = null;
  }

  then(onFulfilled, onRejected) {
    if (!this._dataPromise) {
      this._dataPromise = sendToNative({
        type: messageType,
        action: "query",
        collection: this.collectionName,
        options: this.options
      });
    }
    return this._dataPromise.then(onFulfilled, onRejected);
  }

  catch(onRejected) {
    return this.then(null, onRejected);
  }

  fetchCount() {
    return sendToNative({
      type: messageType,
      action: "query",
      collection: this.collectionName,
      options: { ...this.options, fetchCount: true }
    });
  }
}

const database = {
  get(collectionName) {
    return {
      find: id =>
        sendToNative({ type: messageType, action: "find", collection: collectionName, id }),
      create: data =>
        sendToNative({ type: messageType, action: "create", collection: collectionName, data }),
      update: (id, data) =>
        sendToNative({
          type: messageType,
          action: "update",
          collection: collectionName,
          id,
          data
        }),
      delete: id =>
        sendToNative({ type: messageType, action: "delete", collection: collectionName, id }),
      query: (...args) => {
        const finalOptions = { filters: [] };
        for (const arg of args) {
          if (arg instanceof QueryBuilder) {
            const currentOptions = arg._build();
            if (currentOptions.filters && currentOptions.filters.length > 0) {
              finalOptions.filters.push(...currentOptions.filters);
            }
            delete currentOptions.filters;
            Object.assign(finalOptions, currentOptions);
          }
        }
        return new QueryRequest(collectionName, finalOptions);
      }
    };
  }
};

const synchronize = () => sendToNative({ type: messageType, action: "sync" });

const setActiveDB = (tenantId, userId, authToken) => sendToNative({
  type: messageType,
  action: "setActiveDB",
  payload: { tenantId, userId, authToken }
});

const getLastSyncTime = () => sendToNative({ type: messageType, action: "getLastSyncTime" });

const watermelonBridge = {
  synchronize,
  setActiveDB,
  getLastSyncTime,
  database,
  Q
};
export default watermelonBridge;
